import NoDeviantsWatchedEmptyResultContainer from './NoDeviantsWatchedEmptyResult.container';
import NoDeviantsWatchedEmptyResult from './NoDeviantsWatchedEmptyResult';
export default NoDeviantsWatchedEmptyResultContainer(
  NoDeviantsWatchedEmptyResult
);
